import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_zoom-in",
  "use": "svg_zoom-in-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"svg_zoom-in\"><path d=\"m12.5 11 4.99 5L16 17.49l-5-4.99v-.79l-.27-.28A6.471 6.471 0 0 1 6.5 13 6.5 6.5 0 1 1 13 6.5c0 1.61-.59 3.09-1.57 4.23l.28.27h.79Zm-6 0C8.99 11 11 8.99 11 6.5S8.99 2 6.5 2 2 4.01 2 6.5 4.01 11 6.5 11ZM9 7H7v2H6V7H4V6h2V4h1v2h2v1Z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol